import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useState } from "react";
import { Button, Input } from "src/components";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useDispatch } from "react-redux";
import { eInvoiceExemptUpdate } from "src/services/invoice-api";
import { getOrderDetailsByOrderCode2 } from "src/services/order-api";
import { ordActions } from "src/context/order-slice";

const EwayToggleRemarks = ({ onCloseModal, eWayBillApplicable }: { onCloseModal: () => void, eWayBillApplicable: boolean }) => {
    const { toast } = useToast();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { orderDetailsFiltered } = useSelector((state: RootState) => state.ord);
    const orderDetails = orderDetailsFiltered?.[0];
    const [remarks, setRemarks] = useState<string>("");
    const { withEventCheck } = useEventStatus();
    const dispatch = useDispatch();


    const handleEWayBillApplicable = async () => {
        if (!remarks) {
            toast({ description: "Please enter remarks", variant: "destructive" });
            return;
        }
        setIsLoading(true);
        try {
            const payload = {
                "data": {
                    "order_code": orderDetails?.order_code,
                    "reason": remarks,
                    "order_id": orderDetails?.order_id_int,
                    "eway_exempt": eWayBillApplicable || false,
                    "einv_exempt": orderDetails?.einv_exempt || false,
                    "einvoice_applicable": orderDetails?.novu_metadata?.e_inv_required == "Y" ? true : false,
                    "eway_applicable": orderDetails?.novu_metadata?.e_way_required,
                },
                "primary_key": orderDetails?.order_id_int,
                "event_type": "ORDER_EWAYEINV_UPDATE"
            }
            const response = await eInvoiceExemptUpdate(payload);
            const response2 = await withEventCheck(
                () => {
                    return getOrderDetailsByOrderCode2(orderDetails?.order_code, orderDetails?.company_code);
                },
                response?.data?.data?.eventStreamCreated?.streamId
            );
            dispatch(ordActions.setOrderDetailsFiltered([response2?.data?.data]));
            toast({ description: "E-Way Bill Applicable updated successfully", variant: "default" });
        } catch (error) {
            console.log(error);
            toast({ description: "Failed to update E-Way Bill Applicable", variant: "destructive" });
        } finally {
            setIsLoading(false);
            onCloseModal();
        }
    };

    return (
        <div className="flex flex-col gap-y-2 mb-4 w-[340px] max-h-[318px] mx-auto px-6 bg-white p-4 rounded-xl">
            <div className="flex justify-between items-center">
                <p className="text-lg font-semibold text-gray-800">E-Way Bill Exemption</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
                </Button>
            </div>

            <p className="text-sm text-gray-600 mt-4">
                Are you sure you want to {eWayBillApplicable ? "add" : "remove"} E-Way Bill Exemption?
            </p>


            <Input
                placeholder="Enter remarks"
                value={remarks}
                onChange={(e: any) => setRemarks(e.target.value)}
            />
            <div className="flex justify-end gap-2 mt-4">
                <Button className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg" onClick={onCloseModal}>
                    Cancel
                </Button>
                <Button
                    loaderSize="small"
                    isLoading={isLoading}
                    className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
                    onClick={handleEWayBillApplicable}
                >
                    Proceed
                </Button>
            </div>
        </div>
    );
};

export default EwayToggleRemarks;
